import React, { useEffect, memo } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, BellIcon } from 'lucide-react';
export function ComingSoonPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-cream pt-20 flex items-center justify-center" data-id="element-315">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-id="element-316">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-317">
          <ClockIcon className="w-16 h-16 text-wine mx-auto mb-6" data-id="element-318" />

          <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-319">
            Coming Soon
          </span>

          <h1 className="font-playfair text-5xl md:text-6xl text-charcoal font-bold mb-6" data-id="element-320">
            Our <span className="italic text-wine font-normal" data-id="element-321">Blog</span>
          </h1>

          <p className="text-lg text-brown/70 mb-8 leading-relaxed" data-id="element-322">
            We're crafting stories about wine, custom labels, and memorable
            celebrations. Stay tuned for insights, tips, and inspiration.
          </p>

          <div className="flex items-center justify-center gap-2 text-brown/60 mb-12" data-id="element-323">
            <BellIcon className="w-5 h-5" data-id="element-324" />
            <span className="text-sm" data-id="element-325">We'll notify you when we launch</span>
          </div>

          <a href="/" className="inline-flex items-center px-8 py-4 bg-wine text-white rounded-sm font-medium hover:bg-wine-700 transition-colors" data-id="element-326">
            Back to Home
          </a>
        </motion.div>
      </div>
    </main>;
}